const PlayStore = () => {
  return (
    <svg
      width="125"
      height="38"
      viewBox="0 0 125 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M120.196 36.908H4.71176C2.17111 36.908 0.092392 34.8371 0.092392 32.306V4.69403C0.092392 2.16294 2.17111 0.092041 4.71176 0.092041H120.196C122.737 0.092041 124.815 2.16294 124.815 4.69403V32.306C124.815 34.8371 122.737 36.908 120.196 36.908Z"
        fill="black"
      />
      <path
        d="M120.196 0.092041H4.71176C2.17111 0.092041 0.092392 2.16294 0.092392 4.69403V32.306C0.092392 34.8371 2.17111 36.908 4.71176 36.908H120.196C122.737 36.908 124.815 34.8371 124.815 32.306V4.69403C124.815 2.16294 122.737 0.092041 120.196 0.092041ZM120.196 0.828362C122.336 0.828362 124.076 2.56276 124.076 4.69403V32.306C124.076 34.4376 122.336 36.172 120.196 36.172H4.71176C2.57244 36.172 0.83149 34.4376 0.83149 32.306V4.69403C0.83149 2.56276 2.57244 0.828362 4.71176 0.828362H120.196Z"
        fill="#A6A6A6"
      />
      <path
        d="M43.901 9.51998C43.901 10.2911 43.6718 10.9052 43.2127 11.3633C42.6912 11.908 42.0116 12.1805 41.1762 12.1805C40.3761 12.1805 39.6959 11.9044 39.1365 11.3514C38.576 10.7988 38.2964 10.1135 38.2964 9.29595C38.2964 8.47799 38.576 7.79313 39.1365 7.24015C39.6959 6.68754 40.3761 6.41106 41.1762 6.41106C41.5732 6.41106 41.9533 6.48837 42.3141 6.64263C42.675 6.79726 42.9644 7.0025 43.181 7.25957L42.6937 7.74527C42.3268 7.30845 41.8215 7.09022 41.1762 7.09022C40.5927 7.09022 40.0881 7.29446 39.6623 7.7032C39.2364 8.11241 39.0236 8.64302 39.0236 9.29595C39.0236 9.94888 39.2364 10.4795 39.6623 10.8887C40.0881 11.2975 40.5927 11.5017 41.1762 11.5017C41.7952 11.5017 42.3113 11.2963 42.7244 10.8851C42.9926 10.6172 43.1477 10.2448 43.1892 9.76655H41.1762V9.10322H43.8623C43.8883 9.24745 43.901 9.38587 43.901 9.51998Z"
        fill="white"
      />
      <path
        d="M43.901 9.52004H43.8086C43.8078 10.2736 43.5869 10.8589 43.1474 11.2982L43.1463 11.299L43.146 11.2997C42.6411 11.8256 41.9922 12.0874 41.1762 12.0885C40.3975 12.0874 39.7457 11.8228 39.2014 11.2864C38.6584 10.7489 38.3898 10.0927 38.3888 9.29601C38.3898 8.49895 38.6584 7.84317 39.2014 7.30602C39.7457 6.76925 40.3975 6.50426 41.1762 6.50316C41.5613 6.50316 41.9279 6.57799 42.2776 6.72718C42.6277 6.87748 42.9042 7.07445 43.1102 7.319L43.181 7.25963L43.1157 7.19456L42.6284 7.68062L42.6937 7.74533L42.7649 7.68642C42.3808 7.22797 41.8417 6.99686 41.1762 6.99824C40.571 6.99751 40.0387 7.21288 39.5984 7.63718C39.1538 8.06286 38.9304 8.6233 38.9312 9.29601C38.9304 9.96873 39.1538 10.5292 39.5984 10.9548C40.0387 11.3792 40.571 11.5945 41.1762 11.5938C41.8157 11.5949 42.3607 11.3788 42.7897 10.9502C43.0763 10.664 43.2387 10.2675 43.2813 9.77453L43.2899 9.67458H41.2686V9.19532H43.8623V9.10328L43.7713 9.11948C43.7967 9.25901 43.8086 9.39164 43.8086 9.52004H43.901H43.9934C43.9934 9.38014 43.9803 9.23637 43.9533 9.08681L43.9396 9.01124H41.0838V9.76661V9.85865H43.1892V9.76661L43.0972 9.7587C43.0565 10.2218 42.9085 10.5706 42.6591 10.8201C42.2621 11.2141 41.7749 11.4086 41.1762 11.4097C40.6143 11.409 40.1376 11.2162 39.7265 10.8226C39.3195 10.4303 39.117 9.92952 39.1159 9.29601C39.117 8.6625 39.3195 8.16172 39.7265 7.76944C40.1376 7.37579 40.6143 7.18306 41.1762 7.18232C41.8009 7.18379 42.2726 7.38941 42.6231 7.80469L42.688 7.88164L43.2463 7.32471L43.3062 7.26506L43.2517 7.20064C43.0247 6.93105 42.7223 6.71706 42.3505 6.5582C41.9781 6.39888 41.5851 6.31908 41.1762 6.31908C40.3549 6.31834 39.6461 6.60597 39.0711 7.17514C38.4941 7.74321 38.2033 8.45726 38.204 9.29601C38.2033 10.1344 38.4941 10.8488 39.0715 11.4173C39.6461 11.9861 40.3549 12.2733 41.1762 12.2726C42.0315 12.2733 42.741 11.9903 43.2795 11.4269L43.2127 11.3633L43.278 11.4284C43.7566 10.952 43.994 10.3085 43.9934 9.52004H43.901Z"
        fill="white"
      />
      <path
        d="M48.1594 7.21323H45.635V8.96419H47.9115V9.6278H45.635V11.3788H48.1594V12.0572H44.9233V6.5348H48.1594V7.21323Z"
        fill="white"
      />
      <path
        d="M48.1594 7.21323V7.12119H45.5426V9.05623H47.8191V9.53548L45.5426 9.53576V11.4708H48.067V11.9652H45.0157V6.62684H48.067V7.21323H48.1594V7.12119V7.21323H48.2518V6.5348V6.44276H44.8309V12.1492H48.2518V11.3788V11.2867H45.7274V9.71984H48.0039V8.96419V8.87215H45.7274V7.30527H48.2518V7.21323H48.1594Z"
        fill="white"
      />
      <path
        d="M51.1631 12.0572H50.4503V7.21323H48.9021V6.5348H52.7113V7.21323H51.1631V12.0572Z"
        fill="white"
      />
      <path
        d="M51.1631 12.0572V11.9652H50.5427V7.12119H48.9945V6.62684H52.6189V7.12119H51.0707V12.0572H51.1631V11.9652V12.0572H51.2555V7.30527H52.8037V6.5348V6.44276H48.8097V7.21323V7.30527H50.3579V12.1492H51.1631H51.2555V12.0572H51.1631Z"
        fill="white"
      />
      <path d="M55.4674 12.0572V6.5348H56.1794V12.0572H55.4674Z" fill="white" />
      <path
        d="M55.4674 12.0572H55.5598V6.62684H56.087V11.9652H55.4674V12.0572H55.5598H55.4674V12.1492H56.1794H56.2718V6.44276H55.4674H55.375V12.1492H55.4674V12.0572Z"
        fill="white"
      />
      <path
        d="M59.339 12.0572H58.6262V7.21323H57.0781V6.5348H60.8872V7.21323H59.339V12.0572Z"
        fill="white"
      />
      <path
        d="M59.3389 12.0572V11.9652H58.7186V7.12119H57.1704V6.62684H60.7948V7.12119H59.2466V12.0572H59.3389V11.9652V12.0572H59.4313V7.30527H60.9796V6.5348V6.44276H56.9857V7.21323V7.30527H58.5338V12.1492H59.3389H59.4313V12.0572H59.3389Z"
        fill="white"
      />
      <path
        d="M64.5596 10.8812C64.9699 11.295 65.4719 11.5017 66.0656 11.5017C66.6593 11.5017 67.1616 11.295 67.5712 10.8812C67.9819 10.4673 68.1876 9.93839 68.1876 9.29595C68.1876 8.65351 67.9819 8.12456 67.5712 7.71075C67.1616 7.29694 66.6593 7.09022 66.0656 7.09022C65.4719 7.09022 64.9699 7.29694 64.5596 7.71075C64.15 8.12456 63.9443 8.65351 63.9443 9.29595C63.9443 9.93839 64.15 10.4673 64.5596 10.8812ZM68.0981 11.3435C67.5531 11.9018 66.8754 12.1805 66.0656 12.1805C65.255 12.1805 64.5776 11.9018 64.0338 11.3435C63.4885 10.7858 63.2171 10.1031 63.2171 9.29595C63.2171 8.48876 63.4885 7.80601 64.0338 7.24843C64.5776 6.69003 65.255 6.41106 66.0656 6.41106C66.8711 6.41106 67.547 6.6915 68.0945 7.25202C68.6413 7.81255 68.9148 8.49383 68.9148 9.29595C68.9148 10.1031 68.6419 10.7858 68.0981 11.3435Z"
        fill="white"
      />
      <path
        d="M64.5596 10.8812L64.4939 10.9459C64.9194 11.3763 65.4503 11.5949 66.0656 11.5938C66.6805 11.5949 67.2121 11.3763 67.6369 10.9459C68.0652 10.5152 68.2807 9.95787 68.28 9.29601C68.2807 8.63416 68.0652 8.07686 67.6369 7.64611C67.2121 7.21573 66.6805 6.99714 66.0656 6.99824C65.4503 6.99714 64.9194 7.21573 64.4939 7.64611C64.0666 8.07686 63.8508 8.63416 63.8519 9.29601C63.8508 9.95787 64.0666 10.5152 64.4939 10.9459L64.5596 10.8812L64.6253 10.8165C64.2334 10.4192 64.0374 9.9194 64.0367 9.29601C64.0374 8.67263 64.2334 8.17285 64.6253 7.77552C65.0208 7.37827 65.4932 7.18342 66.0656 7.18232C66.6376 7.18342 67.1111 7.37827 67.5055 7.77552C67.8982 8.17285 68.0941 8.67263 68.0949 9.29601C68.0941 9.9194 67.8982 10.4192 67.5055 10.8165C67.1111 11.2138 66.6376 11.4086 66.0656 11.4097C65.4932 11.4086 65.0208 11.2138 64.6253 10.8165L64.5596 10.8812ZM68.0981 11.3435L68.0321 11.2796C67.5023 11.8203 66.8545 12.0874 66.0656 12.0885C65.2763 12.0874 64.6285 11.8203 64.0998 11.2796L64.0973 11.2767L64.0998 11.2796C63.5711 10.737 63.3102 10.0827 63.3095 9.29601C63.3102 8.50935 63.5711 7.85504 64.0998 7.31247C64.6285 6.77173 65.2763 6.50426 66.0656 6.50316C66.8494 6.50426 67.4958 6.77284 68.0285 7.31642C68.5589 7.86148 68.8213 8.51478 68.8224 9.29601C68.8213 10.0827 68.5597 10.737 68.0321 11.2796L68.0981 11.3435L68.1645 11.4075C68.7246 10.8345 69.0079 10.1236 69.0072 9.29601C69.0079 8.47309 68.7235 7.76374 68.1609 7.18812C67.5979 6.61029 66.8927 6.31807 66.0656 6.31908C65.2341 6.31807 64.5268 6.60891 63.9674 7.18453V7.18416C63.4062 7.75757 63.124 8.46839 63.1247 9.29601C63.124 10.1236 63.4062 10.8345 63.9674 11.4079L63.9699 11.4104L63.9674 11.4075C64.5268 11.9831 65.2341 12.2733 66.0656 12.2726C66.8967 12.2733 67.604 11.9831 68.1645 11.4075L68.0981 11.3435Z"
        fill="white"
      />
      <path
        d="M69.9145 12.0572V6.5348H70.7813L73.4753 10.8309H73.506L73.4753 9.7666V6.5348H74.1881V12.0572H73.4447L70.6261 7.55295H70.5954L70.6261 8.61757V12.0572H69.9145Z"
        fill="white"
      />
      <path
        d="M69.9144 12.0572H70.0068V6.62684H70.73L73.424 10.9229H73.506H73.6009L73.5677 9.76522V6.62684H74.0957V11.9652H73.4959L70.6774 7.46091H70.5954H70.5005L70.5337 8.61904V11.9652H69.9144V12.0572H70.0068H69.9144V12.1492H70.6261H70.7185V8.6161L70.6878 7.55046L70.5954 7.55295V7.64499H70.6261V7.55295L70.5478 7.60191L73.3934 12.1492H74.1881H74.2805V6.44276H73.4753H73.3829V9.7677L73.4136 10.8333L73.506 10.8309V10.7388H73.4753V10.8309L73.5537 10.782L70.8325 6.44276H69.9144H69.8221V12.1492H69.9144V12.0572Z"
        fill="white"
      />
      <path
        d="M98.8877 27.704H100.612V16.1979H98.8877V27.704ZM114.415 20.3426L112.439 25.3311H112.38L110.329 20.3426H108.472L111.548 27.3149L109.794 31.1932H111.593L116.332 20.3426H114.415ZM104.639 26.3971C104.073 26.3971 103.286 26.1159 103.286 25.4199C103.286 24.5318 104.267 24.1914 105.114 24.1914C105.872 24.1914 106.228 24.3542 106.689 24.5764C106.555 25.6421 105.634 26.3971 104.639 26.3971ZM104.847 20.0909C103.598 20.0909 102.306 20.6388 101.771 21.8526L103.301 22.489C103.628 21.8526 104.237 21.6452 104.876 21.6452C105.768 21.6452 106.674 22.1784 106.689 23.1257V23.244C106.377 23.0664 105.709 22.8 104.891 22.8C103.242 22.8 101.562 23.7027 101.562 25.3904C101.562 26.9299 102.915 27.9218 104.43 27.9218C105.589 27.9218 106.228 27.4037 106.63 26.7969H106.689V27.6849H108.353V23.2734C108.353 21.231 106.823 20.0909 104.847 20.0909ZM94.1926 21.7433H91.7406V17.7993H94.1926C95.4814 17.7993 96.2131 18.8623 96.2131 19.7712C96.2131 20.6629 95.4814 21.7433 94.1926 21.7433ZM94.1482 16.1979H90.0176V27.704H91.7406V23.3447H94.1482C96.0588 23.3447 97.937 21.9666 97.937 19.7712C97.937 17.576 96.0588 16.1979 94.1482 16.1979ZM71.6233 26.3992C70.4323 26.3992 69.4351 25.4058 69.4351 24.0414C69.4351 22.6627 70.4323 21.6542 71.6233 21.6542C72.7991 21.6542 73.7218 22.6627 73.7218 24.0414C73.7218 25.4058 72.7991 26.3992 71.6233 26.3992ZM73.6027 20.9869H73.5432C73.1563 20.5273 72.4118 20.1122 71.4742 20.1122C69.5095 20.1122 67.7087 21.8321 67.7087 24.0414C67.7087 26.236 69.5095 27.9412 71.4742 27.9412C72.4118 27.9412 73.1563 27.526 73.5432 27.0518H73.6027V27.6151C73.6027 29.113 72.7991 29.9137 71.5042 29.9137C70.4474 29.9137 69.7925 29.1572 69.5243 28.5197L68.0213 29.1425C68.4529 30.1804 69.599 31.4557 71.5042 31.4557C73.5284 31.4557 75.24 30.2692 75.24 27.3779V20.3494H73.6027V20.9869ZM76.4306 27.704H78.1572V16.1975H76.4306V27.704ZM80.7024 23.9081C80.6577 22.3955 81.8782 21.6246 82.7563 21.6246C83.4414 21.6246 84.0216 21.9655 84.2147 22.4552L80.7024 23.9081ZM86.0606 22.6033C85.7336 21.7282 84.7358 20.1122 82.6967 20.1122C80.6725 20.1122 78.9908 21.6987 78.9908 24.0267C78.9908 26.2213 80.6577 27.9412 82.8902 27.9412C84.6914 27.9412 85.7336 26.8439 86.165 26.2065L84.8254 25.3166C84.3792 25.9692 83.7685 26.3992 82.8902 26.3992C82.0121 26.3992 81.3871 25.9987 80.985 25.2131L86.2389 23.048L86.0606 22.6033ZM44.2016 21.3133V22.9739H48.1904C48.0713 23.9081 47.7588 24.5901 47.2824 25.0646C46.7021 25.6431 45.7942 26.2806 44.2016 26.2806C41.7457 26.2806 39.8258 24.3085 39.8258 21.8619C39.8258 19.4153 41.7457 17.443 44.2016 17.443C45.5263 17.443 46.4935 17.9621 47.2081 18.6294L48.3839 17.4581C47.3867 16.5089 46.0619 15.7823 44.2016 15.7823C40.8377 15.7823 38.0098 18.5108 38.0098 21.8619C38.0098 25.2131 40.8377 27.9412 44.2016 27.9412C46.0176 27.9412 47.3867 27.3484 48.4582 26.236C49.5597 25.1387 49.9022 23.5967 49.9022 22.3513C49.9022 21.9655 49.8725 21.6099 49.8126 21.3133H44.2016ZM54.4371 26.3992C53.2461 26.3992 52.2191 25.4205 52.2191 24.0267C52.2191 22.618 53.2461 21.6542 54.4371 21.6542C55.6276 21.6542 56.6547 22.618 56.6547 24.0267C56.6547 25.4205 55.6276 26.3992 54.4371 26.3992ZM54.4371 20.1122C52.2638 20.1122 50.4925 21.758 50.4925 24.0267C50.4925 26.2806 52.2638 27.9412 54.4371 27.9412C56.6099 27.9412 58.3812 26.2806 58.3812 24.0267C58.3812 21.758 56.6099 20.1122 54.4371 20.1122ZM63.0413 26.3992C61.8508 26.3992 60.8236 25.4205 60.8236 24.0267C60.8236 22.618 61.8508 21.6542 63.0413 21.6542C64.2319 21.6542 65.259 22.618 65.259 24.0267C65.259 25.4205 64.2319 26.3992 63.0413 26.3992ZM63.0413 20.1122C60.8681 20.1122 59.0972 21.758 59.0972 24.0267C59.0972 26.2806 60.8681 27.9412 63.0413 27.9412C65.2143 27.9412 66.9855 26.2806 66.9855 24.0267C66.9855 21.758 65.2143 20.1122 63.0413 20.1122Z"
        fill="white"
      />
      <path
        d="M9.80211 29.9032L9.73346 29.8378C9.46461 29.5544 9.30589 29.1143 9.30589 28.5445V28.6786V8.32309C9.30589 8.32125 9.30589 8.31987 9.30589 8.3184C9.30589 8.32014 9.30589 8.32162 9.30589 8.32346V8.45793C9.30589 7.84089 9.49094 7.37609 9.801 7.0974L21.2476 18.5007L9.80211 29.9032ZM9.30589 8.31729C9.30589 8.26658 9.30728 8.21733 9.30987 8.16883C9.30728 8.21697 9.30589 8.26658 9.30589 8.31729ZM9.30987 8.16662C9.30987 8.16598 9.30986 8.16524 9.31014 8.16451C9.30986 8.16524 9.30987 8.16598 9.30987 8.16662ZM9.31014 8.16018C9.31014 8.15981 9.31014 8.15944 9.31014 8.15907C9.31014 8.15944 9.31014 8.15981 9.31014 8.16018Z"
        fill="url(#paint0_linear_306_5107)"
      />
      <path
        d="M25.0626 22.4379L25.1496 22.3886L29.67 19.8298C30.101 19.5857 30.3882 19.2898 30.5315 18.9767C30.3886 19.2898 30.1013 19.5861 29.67 19.8302L25.1496 22.389L25.0626 22.4379ZM25.0637 22.303L21.2476 18.5007L25.0633 14.699L29.67 17.3063C30.255 17.6374 30.5834 18.0642 30.6383 18.5003C30.6383 18.5007 30.6383 18.5014 30.6383 18.5021C30.5834 18.9371 30.255 19.3643 29.67 19.6954L25.0637 22.303Z"
        fill="url(#paint1_linear_306_5107)"
      />
      <path
        d="M10.6181 30.3375C10.2983 30.3375 10.0193 30.234 9.80174 30.0384L9.80211 30.038C10.0197 30.2336 10.2991 30.3375 10.6188 30.3375C10.6465 30.3375 10.6747 30.3368 10.7033 30.3354C10.6743 30.3368 10.6458 30.3375 10.6181 30.3375ZM10.6184 30.2027C10.2987 30.2031 10.0197 30.0991 9.80211 29.9036V29.9033L21.2476 18.5007L25.0637 22.3031L11.6535 29.8939C11.2824 30.1035 10.9309 30.2027 10.6184 30.2027ZM9.79888 30.0359C9.77865 30.0176 9.75878 29.9982 9.73929 29.978L9.79888 30.0359Z"
        fill="url(#paint2_linear_306_5107)"
      />
      <path
        d="M21.2476 18.5007L9.80099 7.0974C10.0186 6.90218 10.2972 6.79864 10.6166 6.79864C10.9299 6.79864 11.2817 6.89823 11.6535 7.10817L25.0633 14.699L21.2476 18.5007ZM25.1496 14.6131L11.6535 6.97379C11.2817 6.76375 10.9299 6.66417 10.6166 6.66417C10.6151 6.66417 10.6141 6.66417 10.6126 6.66417C10.6145 6.66417 10.6159 6.66417 10.6181 6.66417C10.9306 6.66417 11.2821 6.76339 11.6535 6.97342L25.1496 14.6131Z"
        fill="url(#paint3_linear_306_5107)"
      />
      <path
        d="M10.7033 30.3353C10.9937 30.3188 11.3153 30.2192 11.6535 30.0283L25.0626 22.4379L11.6535 30.0283C11.3156 30.2195 10.9937 30.3188 10.7033 30.3353ZM9.80175 30.0383L9.79889 30.0358C9.7999 30.0366 9.80101 30.0376 9.80175 30.0383ZM9.7393 29.9779L9.73347 29.9722V29.9719C9.73569 29.974 9.73745 29.9761 9.7393 29.9779Z"
        fill="black"
      />
      <path
        d="M25.0626 22.4379L25.1496 22.3886L25.0626 22.4379Z"
        fill="url(#paint4_linear_306_5107)"
      />
      <path
        d="M10.6188 30.3375C10.2991 30.3375 10.0197 30.2336 9.80212 30.038L9.80175 30.0384C9.80101 30.0377 9.7999 30.0366 9.79889 30.0359L9.7393 29.978C9.73745 29.9762 9.73569 29.9741 9.73347 29.9719L9.80212 29.9036C10.0197 30.0991 10.2987 30.2031 10.6185 30.2027C10.9309 30.2027 11.2824 30.1035 11.6535 29.8939L25.0637 22.3031L25.1496 22.3887L25.0626 22.4379L11.6535 30.0284C11.3153 30.2193 10.9937 30.3188 10.7033 30.3354C10.6747 30.3368 10.6465 30.3375 10.6188 30.3375Z"
        fill="url(#paint5_linear_306_5107)"
      />
      <path
        d="M9.73346 29.9723C9.46461 29.6889 9.30589 29.2489 9.30589 28.679V28.6787C9.30589 29.2489 9.46461 29.6885 9.73346 29.9719V29.9723Z"
        fill="black"
      />
      <path
        d="M9.73346 29.9719C9.46461 29.6885 9.30589 29.2489 9.30589 28.6787V28.5446C9.30589 29.1144 9.46461 29.5544 9.73346 29.8378L9.80211 29.9033L9.73346 29.9719Z"
        fill="url(#paint6_linear_306_5107)"
      />
      <path
        d="M9.73347 29.9719L9.80212 29.9033V29.9035L9.73347 29.9719Z"
        fill="url(#paint7_linear_306_5107)"
      />
      <path
        d="M30.5315 18.9767C30.6026 18.8214 30.6383 18.6618 30.6383 18.5021C30.6383 18.5018 30.6383 18.5015 30.6383 18.5015C30.6383 18.6614 30.6026 18.821 30.5315 18.9767Z"
        fill="black"
      />
      <path
        d="M25.1496 22.3886L25.0636 22.303L29.67 19.6953C30.255 19.3643 30.5834 18.9371 30.6383 18.502C30.6383 18.6617 30.6025 18.8213 30.5315 18.9767C30.3882 19.2898 30.101 19.5857 29.67 19.8298L25.1496 22.3886Z"
        fill="url(#paint8_linear_306_5107)"
      />
      <path
        d="M30.6383 18.5007V18.5003C30.6379 18.0188 30.3149 17.5375 29.67 17.1722L25.1496 14.6134H25.1492L25.1496 14.6131L29.67 17.1718C30.3157 17.5371 30.639 18.0192 30.6383 18.5007Z"
        fill="#404040"
      />
      <path
        d="M30.6383 18.5003C30.5834 18.0642 30.255 17.6374 29.67 17.3063L25.0633 14.699L25.1492 14.6134H25.1496L29.67 17.1722C30.315 17.5375 30.6379 18.0188 30.6383 18.5003Z"
        fill="url(#paint9_linear_306_5107)"
      />
      <path
        d="M9.30589 8.31842C9.30589 8.31805 9.30589 8.31768 9.30589 8.31732C9.30589 8.31768 9.30589 8.31805 9.30589 8.31842ZM9.30987 8.16886C9.30987 8.16812 9.30987 8.16738 9.30987 8.16665C9.30987 8.16738 9.30987 8.16812 9.30987 8.16886ZM9.31014 8.16453C9.31014 8.16306 9.31014 8.16168 9.31014 8.1602C9.31014 8.16168 9.31014 8.16306 9.31014 8.16453ZM9.31014 8.1591C9.36363 7.21358 9.87971 6.66741 10.6098 6.66419C10.2932 6.66603 10.0176 6.76958 9.80173 6.96332V6.96295L9.79915 6.96553C9.77642 6.98596 9.7548 7.00759 9.73346 7.02986C9.49094 7.28546 9.33795 7.66835 9.31014 8.1591Z"
        fill="#404040"
      />
      <path
        d="M9.30589 8.45795V8.32348C9.30589 8.32164 9.30589 8.32016 9.30589 8.31842C9.30589 8.31805 9.30589 8.31768 9.30589 8.31731C9.30589 8.2666 9.30728 8.21699 9.30987 8.16885C9.30987 8.16811 9.30987 8.16738 9.30987 8.16664C9.30987 8.166 9.30986 8.16526 9.31014 8.16452C9.31014 8.16305 9.31014 8.16167 9.31014 8.1602C9.31014 8.15983 9.31014 8.15946 9.31014 8.15909C9.33795 7.66834 9.49094 7.28545 9.73346 7.02986L9.801 7.09741C9.49094 7.37611 9.30589 7.84091 9.30589 8.45795ZM9.79915 6.96552L9.80174 6.96294C9.801 6.96405 9.79989 6.96478 9.79915 6.96552Z"
        fill="url(#paint10_linear_306_5107)"
      />
      <path
        d="M25.0633 14.699L11.6535 7.10818C11.2817 6.89823 10.9299 6.79865 10.6166 6.79865C10.2972 6.79865 10.0186 6.90219 9.80101 7.09741L9.73347 7.02985C9.75482 7.00758 9.77643 6.98595 9.79916 6.96551C9.7999 6.96478 9.80101 6.96404 9.80175 6.9633C10.0176 6.76956 10.2932 6.66602 10.6098 6.66418C10.6105 6.66418 10.6115 6.66418 10.6126 6.66418C10.6141 6.66418 10.6151 6.66418 10.6166 6.66418C10.9299 6.66418 11.2817 6.76376 11.6535 6.9738L25.1496 14.6131L25.1492 14.6134L25.0633 14.699Z"
        fill="url(#paint11_linear_306_5107)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_306_5107"
          x1="20.2326"
          y1="8.10836"
          x2="4.78616"
          y2="23.6131"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.00657445" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_306_5107"
          x1="31.3511"
          y1="18.5012"
          x2="8.99612"
          y2="18.5012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_306_5107"
          x1="23.0294"
          y1="20.6133"
          x2="2.08283"
          y2="41.639"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_306_5107"
          x1="6.83416"
          y1="0.254149"
          x2="16.1876"
          y2="9.64294"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_306_5107"
          x1="31.3511"
          y1="18.5015"
          x2="8.99619"
          y2="18.5015"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CCB300" />
          <stop offset="0.4087" stopColor="#CC9700" />
          <stop offset="0.7754" stopColor="#CC8400" />
          <stop offset="1" stopColor="#CC7D00" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_306_5107"
          x1="23.0294"
          y1="20.6133"
          x2="2.08285"
          y2="41.639"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#CC2E36" />
          <stop offset="1" stopColor="#9C0E4E" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_306_5107"
          x1="20.2327"
          y1="8.10843"
          x2="4.7862"
          y2="23.6133"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#008DE0" />
          <stop offset="0.00657445" stopColor="#008DE0" />
          <stop offset="0.2601" stopColor="#00A7E0" />
          <stop offset="0.5122" stopColor="#00B8E0" />
          <stop offset="0.7604" stopColor="#00C4E0" />
          <stop offset="1" stopColor="#00C7E0" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_306_5107"
          x1="23.0297"
          y1="20.6134"
          x2="2.08347"
          y2="41.6396"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0333C" />
          <stop offset="1" stopColor="#AB0F56" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_306_5107"
          x1="31.3511"
          y1="18.5012"
          x2="8.99611"
          y2="18.5012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0C500" />
          <stop offset="0.4087" stopColor="#E0A600" />
          <stop offset="0.7754" stopColor="#E09100" />
          <stop offset="1" stopColor="#E08900" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_306_5107"
          x1="31.3511"
          y1="18.5012"
          x2="8.99614"
          y2="18.5012"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE840" />
          <stop offset="0.4087" stopColor="#FFCE40" />
          <stop offset="0.7754" stopColor="#FFBC40" />
          <stop offset="1" stopColor="#FFB540" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_306_5107"
          x1="20.2326"
          y1="8.10838"
          x2="4.78616"
          y2="23.6132"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40B8FF" />
          <stop offset="0.00657445" stopColor="#40B9FF" />
          <stop offset="0.2601" stopColor="#40CEFF" />
          <stop offset="0.5122" stopColor="#40DDFF" />
          <stop offset="0.7604" stopColor="#40E7FF" />
          <stop offset="1" stopColor="#40EAFF" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_306_5107"
          x1="6.83418"
          y1="0.254154"
          x2="16.1877"
          y2="9.64294"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#65B895" />
          <stop offset="0.0685" stopColor="#62BD95" />
          <stop offset="0.4762" stopColor="#50DB97" />
          <stop offset="0.8009" stopColor="#44ED98" />
          <stop offset="1" stopColor="#40F498" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PlayStore;
